import React, { useEffect, useState } from 'react';
import { rootUrl } from '../../../config/config';
import { useAuth } from '../AuthContext';
import { Link } from 'react-router-dom';

export default function BlacklistedDrivers() {
    const { token } = useAuth();
    const [drivers, setDrivers] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!token) return;
        setLoading(true);
        // fetch many drivers then filter client-side for blacklisted
        fetch(`${rootUrl}/drivers?limit=1000`, { headers: { Authorization: `Bearer ${token}` } })
            .then(r => r.json())
            .then(j => {
                const rows = j.data || j;
                setDrivers((rows || []).filter(d => d.is_blacklisted));
            })
            .catch(() => setDrivers([]))
            .finally(() => setLoading(false));
    }, [token]);

    return (
        <div className="p-6">
            <div className="text-2xl font-semibold mb-4">Blacklisted Drivers</div>
            {loading && <div>Loading...</div>}
            {!loading && drivers.length === 0 && <div className="text-sm text-gray-600">No blacklisted drivers found.</div>}
            {!loading && drivers.length > 0 && (
                <div className="space-y-2">
                    {drivers.map(d => (
                        <div key={d.id} className="bg-white p-3 rounded shadow-sm flex justify-between items-center">
                            <div>
                                <div className="font-medium">{d.name}</div>
                                <div className="text-sm text-gray-500">{d.phone} • {d.id_no}</div>
                                <div className="text-sm text-red-600">Reason: {d.blacklist_reason || '—'}</div>
                            </div>
                            <div>
                                <Link to={`/drivers/${d.id_no}`} className="text-sm text-[#FF5733] hover:underline">View</Link>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
